var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSizeOptionSmallOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3906 0.65625L23.0156 10.0312C23.2891 10.2656 23.2891 10.6562 23.0938 10.9297C22.8594 11.2031 22.4688 11.2031 22.1953 10.9688L20.75 9.67969V17.375C20.75 19.1328 19.3438 20.5 17.625 20.5H6.375C4.61719 20.5 3.25 19.1328 3.25 17.375V9.67969L1.76562 10.9688C1.53125 11.2031 1.10156 11.2031 0.90625 10.9297C0.671875 10.6562 0.671875 10.2656 0.945312 10.0312L11.5703 0.65625C11.8047 0.460938 12.1562 0.460938 12.3906 0.65625ZM4.5 17.375C4.5 18.4297 5.32031 19.25 6.375 19.25H8.875V13C8.875 12.3359 9.42188 11.75 10.125 11.75H13.875C14.5391 11.75 15.125 12.3359 15.125 13V19.25H17.625C18.6406 19.25 19.5 18.4297 19.5 17.375V8.58594L12 1.98438L4.5 8.58594V17.375ZM10.125 19.25H13.875V13H10.125V19.25Z",
    fill: "#8791B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeOptionSmallOffice);
export default __webpack_public_path__ + "static/media/size-option-small-office.74116bd5bb5ef82d056d6acd9e9370cd.svg";
export { ForwardRef as ReactComponent };